import { render } from "./mp-popover.vue?vue&type=template&id=5b8fb8e0"
import script from "./mp-popover.vue?vue&type=script&lang=ts"
export * from "./mp-popover.vue?vue&type=script&lang=ts"

import "./mp-popover.vue?vue&type=style&index=0&id=5b8fb8e0&lang=less&scope=true"
script.render = render

export default script